@use '@fpsm/cxy-scss' as cxy;

.loginForm {
  @include cxy.stack(var(--cxy-spacing-xxsm));
}
.loginForm .buttonSection button {
  text-transform: uppercase;
  margin-top: var(--cxy-spacing-xxsm);
  width: 100%;
}

.errorMessage {
  color: #fca5a5;
}

.checkboxSection {
  display: flex;
  align-items: center;
  margin-top: var(--cxy-spacing-xxsm);
  width: 100%;
}

.checkboxLabel {
  margin-left: var(--cxy-spacing-xxxsm);
  font-size: 0.875rem;
}

.forgotPassword {
  margin-left: auto;
  font-size: 0.875rem;
  color: var(--cxy-color-content-default);
  text-decoration: underline;
}

.signupText {
  font-size: 1rem;
  text-align: center;
  font-weight: bold;
}

.signupLink {
  color: var(--cxy-color-brand);
  text-decoration: underline;
}

/* WhoScored theme override */
[data-fpsm-theme='whoscored'] .loginForm .buttonSection button {
  color: var(--cxy-color-text-default-placeholder);
}
